import React from "react";
import { useLocation } from "react-router-dom";

import Report from "../components/Report";
import ReportList from "../components/ReportList";

export default function Reports() {
    let query = useQuery();
    let report = query.get("report");
    let plotId = query.get("plotId");
    return (
        <div className="reports-container">
            {report ? (
                <Report report={report} plotId={plotId} />
            ) : (
                <div>
                    <ReportList />
                </div>
            )}
        </div>
    );
}

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => {
        const cleanSearch = search.endsWith("/") ? search.slice(0, -1) : search;
        return new URLSearchParams(cleanSearch);
    }, [search]);
}
